import { axios } from "../../../lib/axios";

export const getUserSearchFilter = async (searchValue: any) => {
  const response = await axios.get(`/user?name=${searchValue}`);

  return response.data;
};
